import { render, staticRenderFns } from "./auth-app.vue?vue&type=template&id=4c38d994&"
import script from "./auth-app.vue?vue&type=script&lang=js&"
export * from "./auth-app.vue?vue&type=script&lang=js&"
import style0 from "./auth-app.vue?vue&type=style&index=0&id=4c38d994&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports